export enum IS_HISPANIC {
    YES = "H",
    NO = "AU",
    OTHER = "AU_other",
    PREFER_NOT_TO_ANSWER  = "AE",
}

export enum NON_HISPANIC_RACE_ETHNICITY {
    AMERICAN_INDIAN_OR_ALASKAN_NATIVE = "G",
    ASIAN_INDIAN = "D",
    BLACK_OR_AFRICAN_AMERICAN = "B",
    CHINESE = "AI",
    FILIPINO = "AJ",
    GUAMANIAN_OR_CHAMORRO = "AK",
    JAPANESE = "AL",
    KOREAN = "AM",
    NATIVE_HAWAIIAN = "J",
    SAMOAN = "AN",
    VIETNAMESE = "AO",
    WHITE = "C",
    ASIAN_RACE_NOT_LISTED_ABOVE = "A",
    PACIFIC_ISLANDER_RACE_NOT_LISTED_ABOVE = "J_other",
    RACE_NOT_LISTED_ABOVE = "E",
    OTHER = "E_other",
    PREFER_NOT_TO_ANSWER = "8"
}